// extracted by mini-css-extract-plugin
export default {"root_image_inner":"mediaNewsForm_root_image_inner__5BXtd","formTabs_root":"mediaNewsForm_formTabs_root__HBw9A"};